import { render, staticRenderFns } from "./MeasurementOptions.vue?vue&type=template&id=4825fc60&scoped=true&"
import script from "./MeasurementOptions.vue?vue&type=script&lang=js&"
export * from "./MeasurementOptions.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementOptions.vue?vue&type=style&index=0&id=4825fc60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4825fc60",
  null
  
)

export default component.exports